// extracted by mini-css-extract-plugin
export default {"emptyWrapper":"TableScenariosList_emptyWrapper__Ggz8H","emptyTitle":"TableScenariosList_emptyTitle__hFmos","emptyDescription":"TableScenariosList_emptyDescription__nkmKZ"};